import React from "react";
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Badge,
  Card,
  CardBody,
  CardTitle,
  CardText,
  ListGroup,
  ListGroupItem
} from "reactstrap";
import "../utils/style.css"
import { Tag } from "antd";

const DetailCompany = ({ modal, setModal, toggle, selectedCompany, currentuser }) => {
  const developpers = Array.isArray(selectedCompany?.developerAccounts) ? selectedCompany.developerAccounts : [];

  return (
    <Modal
      id="showModalClient"
      isOpen={modal}
      toggle={toggle}
      centered
      backdrop="static"
      style = {{maxWidth:"1000px"}}
    >
      <ModalHeader
        className="active-tab"
        toggle={toggle}
        style={{
          borderTopLeftRadius: "15px",
          borderTopRightRadius: "15px",
          fontWeight: "bold"
        }}
      >
        <h4>Détails de mon entreprise <Tag size="large" color="default">{selectedCompany?.name}</Tag></h4>
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col md={12}>
            <Card className="mb-4 shadow-sm rounded-3">
              <CardBody>
                <CardTitle tag="h5" className="text-primary text-center">
                  Informations supplémentaire
                </CardTitle>
                <ListGroup flush>
                  <ListGroupItem className="d-flex justify-content-between align-items-center">
                    <strong>Nom</strong>
                    <span>{selectedCompany?.name || "Non spécifié"}</span>
                  </ListGroupItem>
                  <ListGroupItem className="d-flex justify-content-between align-items-center">
                    <strong>Etat</strong>
                    <span>{selectedCompany?.kycValidated || "Non spécifié"}</span>
                  </ListGroupItem>
                  <ListGroupItem className="d-flex justify-content-between align-items-center">
                    <strong>Nationalité</strong>
                    <span>{selectedCompany?.nationality || "Non spécifié"}</span>
                  </ListGroupItem>
                  <ListGroupItem className="d-flex justify-content-between align-items-center">
                    <strong>Numéro d'identité</strong>
                    <span>{selectedCompany?.identityNumber || "Non spécifié"}</span>
                  </ListGroupItem>
                  <ListGroupItem className="d-flex justify-content-between align-items-center">
                    <strong>Date d'expiration pièce</strong>
                    <span>{new Date(selectedCompany?.identityExpirationDate).toLocaleDateString() || "Non spécifié"}</span>
                  </ListGroupItem>
                  <ListGroupItem className="d-flex justify-content-between align-items-center">
                    <strong>Statut KYC</strong>
                    <Badge color={selectedCompany?.kycStatus === "APPROUVE" ? "success" : "danger"}>
                      {selectedCompany?.kycStatus || "Non spécifié"}
                    </Badge>
                  </ListGroupItem>
                  <ListGroupItem className="d-flex justify-content-between align-items-center">
                    <strong>Date de validation KYC</strong>
                    <span>{new Date(selectedCompany?.kycValidationDate).toLocaleDateString() || "Non spécifié"}</span>
                  </ListGroupItem>
                  <ListGroupItem className="d-flex justify-content-between align-items-center">
                    <strong>Nombre d'applications</strong>
                    <span>{developpers.length || "Aucun"}</span>
                  </ListGroupItem>
                </ListGroup>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter className="d-flex justify-content-center">
        <Button color="secondary" onClick={toggle} style={{ borderRadius: "25px" }} className="active-tab mb-4 shadow-sm rounded-3">
          Fermer
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DetailCompany;
